(function ($, utils, dom) {
	$(function () {
	/* ------- Contacts Map ------- */
		if (typeof initConfig != 'undefined') {
			$.each(initConfig.map, function(index, el) {
				var idMap = el.id,
					$mapBox = $('#'+idMap),
					start = false,
					yamapCheckAndInit = function () {
						if ( !start && ($mapBox.filter(':in-viewport').length) ) { // $.inViewport($mapBox)
							utils.loadYandexMapAPI(app.contactsMap.init, {
								idMapBox: idMap,
								placemarks: el.placemarks
							});
							start = true;
						}
					};

				yamapCheckAndInit();
				var scrollTimer;

				dom.$window.on('scroll', function () {
					clearTimeout(scrollTimer);
					scrollTimer = setTimeout(yamapCheckAndInit, 150);
				});
			});
		}
	});
})(jQuery, app.utils, app.dom);